var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ExportSettings_1;
import { ConnectionType } from '@symon-ai/wisepipe-common-connection';
import { JSON, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { exportSettingsSchemaValidation } from '../validations.generated';
// make sure your actual target calls are `target-${exportType}`, ie target-tq-postgres
// otherwise update exportUtils' getTargetCommand()
export var ExportType;
(function (ExportType) {
    ExportType["GSheets"] = "gsheets";
    ExportType["Icm"] = "icm";
    ExportType["Postgres"] = "postgres";
    ExportType["TqPostgres"] = "tq-postgres";
    ExportType["PowerBI"] = "powerbi";
    ExportType["Symon"] = "symon";
    ExportType["Salesforce"] = "salesForce";
    ExportType["WorkdayPayroll"] = "workday-payroll";
    ExportType["Tableau"] = "tableau";
    ExportType["Tqp"] = "tqp";
    ExportType["Sftp"] = "sftp";
    ExportType["AmazonS3"] = "s3-csv";
    ExportType["Snowflake"] = "snowflake";
    ExportType["S3Parquet"] = "s3parquet";
    ExportType["MsSql"] = "msSql";
    ExportType["OneDrive"] = "oneDrive";
})(ExportType || (ExportType = {}));
export var ExportSupportedFileType;
(function (ExportSupportedFileType) {
    ExportSupportedFileType["Csv"] = ".csv";
    ExportSupportedFileType["Excel"] = ".xlsx";
    ExportSupportedFileType["Text"] = ".txt";
})(ExportSupportedFileType || (ExportSupportedFileType = {}));
export const exportSettingsSchema = {
    $id: 'urn:wisepipe-common-export:ExportSettings',
    type: 'object',
    properties: {
        exportType: {
            type: 'string',
            enum: Object.values(ExportType)
        }
    },
    required: ['exportType']
};
let ExportSettings = ExportSettings_1 = class ExportSettings {
    constructor(exportType) {
        this.exportType = exportType;
        JSON.validate(this, ExportSettings_1);
    }
    static getConnectionType(exportType) {
        switch (exportType) {
            case ExportType.GSheets:
                return ConnectionType.GSheetsExport;
            case ExportType.Icm:
                return ConnectionType.Icm;
            case ExportType.TqPostgres:
                return ConnectionType.TqPostgres;
            case ExportType.Symon:
                return ConnectionType.Symon;
            case ExportType.Salesforce:
                return ConnectionType.SalesForce;
            case ExportType.Tableau:
                return ConnectionType.Tableau;
            case ExportType.Tqp:
                return ConnectionType.Tqp;
            case ExportType.WorkdayPayroll:
                return ConnectionType.Workday;
            case ExportType.PowerBI:
                return ConnectionType.PowerBI;
            case ExportType.Sftp:
                return ConnectionType.Sftp;
            case ExportType.AmazonS3:
                return ConnectionType.AmazonS3Export;
            case ExportType.Snowflake:
                return ConnectionType.Snowflake;
            case ExportType.MsSql:
                return ConnectionType.MsSql;
            case ExportType.OneDrive:
                return ConnectionType.OneDriveExport;
            default:
                throw new Error(`No export connection type found for exporting to ${exportType}`);
        }
    }
    static requiresAwsS3Creds(exportType) {
        return [ExportType.Icm, ExportType.Tqp].includes(exportType);
    }
    // if export is not pipeline, we do not discover and only extract
    static isSingerExport(exportType) {
        return ![ExportType.Icm, ExportType.Tqp].includes(exportType);
    }
    get isExcelExport() {
        return false;
    }
};
ExportSettings = ExportSettings_1 = __decorate([
    JsonSchemaV2(exportSettingsSchema, exportSettingsSchemaValidation),
    JsonDiscriminatorProperty('exportType')
], ExportSettings);
export { ExportSettings };
//# sourceMappingURL=exportSettings.js.map